var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
var PasswordForm = /** @class */ (function (_super) {
    __extends(PasswordForm, _super);
    function PasswordForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.required = function (value) { return value ? '' : _this.props.intl.formatMessage({ id: 'withdraw.required' }); };
        _this.maxLength = function (value) { return value && value.length < 6 ? _this.props.intl.formatMessage({ id: 'join.password.hint' }) : undefined; };
        _this.includeOneNumber = function (value) { return value && !/\d/.test(value) ? _this.props.intl.formatMessage({ id: 'join.password.hint' }) : undefined; };
        _this.includeOneUpperCase = function (value) { return value && !/[A-Z]/.test(value) ? _this.props.intl.formatMessage({ id: 'join.password.hint' }) : undefined; };
        _this.mustMatch = function (value, allValues) { return value !== allValues.newpassword ? _this.props.intl.formatMessage({ id: 'join.errors.password_repeat' }) : undefined; };
        _this.renderField = function (_a) {
            var input = _a.input, _b = _a.placeholder, placeholder = _b === void 0 ? {} : _b, type = _a.type, _c = _a.meta, touched = _c.touched, error = _c.error, warning = _c.warning;
            return (_jsxs("div", __assign({ className: 'input' }, { children: [_jsx("input", __assign({}, input, { placeholder: placeholder, type: type, autoComplete: 'new-password' })), touched && ((error && _jsx("div", __assign({ className: 'important' }, { children: error }))) || (warning &&
                        _jsx("div", __assign({ className: 'important' }, { children: warning }))))] })));
        };
        return _this;
    }
    PasswordForm.prototype.render = function () {
        var _a = this.props, submitAction = _a.submitAction, handleSubmit = _a.handleSubmit, intl = _a.intl, passwordNotMatch = _a.passwordNotMatch, smsRecoveryError = _a.smsRecoveryError, smsRecover = _a.smsRecover;
        return (_jsxs("form", __assign({ onSubmit: handleSubmit(submitAction), id: 'create-password' }, { children: [passwordNotMatch && _jsx("div", __assign({ className: 'error' }, { children: intl.formatMessage({ id: 'join.errors.password_repeat' }) })), smsRecoveryError && _jsx("div", __assign({ className: 'error' }, { children: intl.formatMessage({ id: 'join.errors.error' }) })), smsRecover && _jsx(Field, { type: 'text', component: this.renderField, name: 'code', placeholder: intl.formatMessage({ id: 'join.fast.phone_confirm.confirmation_code' }), validate: [this.required] }), _jsx(Field, { type: 'password', component: this.renderField, name: 'newpassword', placeholder: intl.formatMessage({ id: 'join.password' }), validate: [this.required, this.maxLength, this.includeOneNumber, this.includeOneUpperCase] }), _jsx(Field, { type: 'password', component: this.renderField, name: 'confpassword', placeholder: intl.formatMessage({ id: 'join.password_repeat' }), validate: [this.required, this.maxLength, this.includeOneNumber, this.includeOneUpperCase, this.mustMatch] }), _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ type: 'submit' }, { children: intl.formatMessage({ id: 'recharge.save' }) })) }))] })));
    };
    return PasswordForm;
}(React.Component));
PasswordForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitAction: PropTypes.func.isRequired,
    passwordNotMatch: PropTypes.bool,
    smsRecover: PropTypes.bool,
    intl: PropTypes.object.isRequired
};
PasswordForm = reduxForm({
    form: 'create-password'
})(PasswordForm);
export default injectIntl(PasswordForm);



// WEBPACK FOOTER //
// ./src/components/shared/changePassword/PasswordForm.jsx